module.exports = {
  arrowLeft: require('./arrowLeft'),
  arrowRight: require('./arrowRight'),
  close: require('./close'),
  exitfull: require('./exitfull'),
  full: require('./full'),
  pause: require('./pause'),
  play: require('./play')
}



// WEBPACK FOOTER //
// ./assets/vue/components/images/assets/icons/index.js